import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {NgxSpinnerService} from 'ngx-spinner';
import {Card, ImageAsset, ImageAssetFactory, ImageAssetType} from '../../domain/card';
import {ImageManipulationService, IResizeImageOptions} from '../../core/image-manipulation.service';
import {ImageCaptureAction} from '../../domain/card-actions/image-capture.action';

@Component({
  selector: 'crds-image-capture-form',
  templateUrl: './image-capture-form.component.html'
})
export class ImageCaptureFormComponent implements OnInit {

  @Input() form: FormGroup;
  @Input() card: Card<ImageCaptureAction>;
  action: ImageCaptureAction;
  images: ImageAsset[];
  imageAssetType = ImageAssetType;

  constructor(private imageService: ImageManipulationService,
              private spinnerService: NgxSpinnerService,
              private imageAssetFactory: ImageAssetFactory) {
  }

  ngOnInit() {
    this.action = this.card.action;
    this.images = this.imageAssetFactory.create(this.card.image, this.form);
  }

  clickFile() {
    (document.getElementsByClassName('imageCapture')[0] as HTMLElement).click();
  }

  setFromImage(event) {
    this.spinnerService.show();
    const file: File = event.target.files[0];
    const maxSize = 1000;
    const targetFormControl = this.form.get(this.action.targetField);
    let orientationTemp = 1;

    setTimeout(() => {
      this.spinnerService.hide();
    }, 10000);

    return this.imageService.resetOrientation(file)
      .then((reorientationResult: { result: string, orientation: number }) => {
        orientationTemp = reorientationResult.orientation;
        const options: IResizeImageOptions = {
          maxSize: maxSize,
          b64: reorientationResult.result
        };
        this.imageService.resizeImage(options)
          .then((resizedImage) => {
            targetFormControl.patchValue(resizedImage);
            this.spinnerService.hide();
          });
      });
  }
}
